import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class WorkflowContextBase  {
    _originalTypeClassName = "zAppDev.DotNet.Framework.Workflow.WorkflowContextBase";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
WorkflowContextBase.translate = translateService;
}
this.Name = null;
this.Error = null;
this.Expires = false;
this.ExpirationDateTime = null;
this.PendingSince = null;
this.PendingJobCreatedBy = null;
this.PendingStep = null;
this.Id = null;
this.Status = null;
this._key = this.Id = "00000000-0000-0000-0000-000000000000"; 
}

static translate: TranslateService;
_key: any;
Name:any;
Error:any;
Expires:any;
ExpirationDateTime:any;
PendingSince:any;
PendingJobCreatedBy:any;
PendingStep:any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Status:any;
Result:any;
static setResult = ($this, value) => {
var oldValue = $this.Result;
$this.Result = value;
if (value != null) {
if (oldValue != null && oldValue.Context != null) { oldValue.Context = null; }
if ($this.Result.Context !== $this) {
Domain.WorkflowExecutionResult.setContext(value, $this);
}
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == "00000000-0000-0000-0000-000000000000";
            }


}